<template>
  <div class="media-container">
    <a class="media-content" v-for="item in media"
         target="_blank"
         :href="item.url"
         :key="item">
      <img :src="getUrlMedia(item.id + `${ isActiveDark ? '-dark' : ''}`)" alt="media">
    </a>
  </div>
</template>

<script>
export default {
  name: "MediaBlock",
  props: {
    isActiveDark: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      media: [
        {
          id: 1,
          url: 'https://www.google.com'
        },
        {
          id: 2,
          url: 'https://www.google.com'
        },
        {
          id: 3,
          url: 'https://www.google.com'
        }
      ]
    }
  },
  methods: {
    getUrlMedia(picture) {
      return require(`@/assets/media/${ picture }.svg`)
    },
  }
}
</script>

<style scoped lang="scss">
  .media-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    .media-content {
      transition: all .3s ease;
      cursor: pointer;
      &:hover {
        opacity: .6;
      }
      & img {
        width: 100%;
        height: 100%;
      }
    }
  }



  @media (max-width: 3024px){
    .media-container {
      column-gap: 80px;
      .media-content {
        width: 40px;
        height: 40px;
      }
    }
  }


  @media (max-width: 1920px) {
    .media-container {
      column-gap: 80px;
      .media-content {
        width: 32px;
        height: 32px;
      }
    }
  }


  @media (max-width: 1600px) {
    .media-container {
      column-gap: 56px;
      .media-content {
        width: 24px;
        height: 24px;
      }
    }

  }
  @media (max-height: 800px) {
    .media-container {
      column-gap: 56px;
      .media-content {
        width: 16px;
        height: 16px;
      }
    }
  }

  @media (max-width: 1400px) and (min-height: 801px) {
    .media-container {
      column-gap: 56px;
      .media-content {
        width: 24px;
        height: 24px;
      }
    }
  }

  @media (max-width: 1133px) {
    .media-container {
      column-gap: 56px;
      .media-content {
        width: 16px;
        height: 16px;
      }
    }
  }

  @media (max-width: 769px) {
    .media-container {
      column-gap: 32px;
      .media-content {
        width: 24px;
        height: 24px;
      }
    }
    //14
  }

  @media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
    //plus
  }

  @media (min-height: 600px) and (max-height: 630px){

    //8 plus
  }

  @media (max-width: 375px) {
    //se new
  }

  @media (max-width: 375px) and (min-height: 630px) {
    //x
  }


  @media (max-width: 320px) {
    //se old
  }

  @media (min-width: 3025px) {

    .media-container {
      column-gap: 176px;
      .media-content {
        width: 56px;
        height: 56px;
      }
    }
  }

</style>